<template>
<div class="chapter">
<div class="inner_page">
<h1>Bad Boy</h1>
<h2 class="sigil_not_in_toc" style="text-align: center;">Olivia Goldsmith</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_title.vue?dbb75042